export default {
      id: "icon-logo-usage",
      viewBox: "0 0 278 41.029",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-logo",
      toString: function () {
        return this.url;
      }
    }